// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1gy6g","label":"CategoryService_label__2UFV-","location":"CategoryService_location__2AQzz"};